(function () {
  'use strict';
  if (window.fotoMasterLeadV2) return;
  const intents = ['buy', 'software', 'rent', 'support', 'other'];
  const businesses = ['starting', 'expanding', 'organization', 'unsure'];
  function priority(value) {
    if (/urgent|within a week|30 days/i.test(value)) return 'hot';
    if (/couple of months/i.test(value)) return 'warm';
    return 'nurture';
  }
  function prefill(catalog, page, hash) {
    let explicit = '';
    try { explicit = new URLSearchParams(String(hash || '').replace(/^#/, '')).get('product') || ''; } catch (_) {}
    const byTitle = catalog.find(p => p.title.toLowerCase() === explicit.toLowerCase() || p.handle === explicit);
    if (byTitle) return byTitle;
    let handle = page.product_handle || page.resource_handle || String(page.path || '').split('/').pop();
    const pageProducts = {
      'fmbooth-for-windows': 'fmbooth-windowsos', 'fmbooth-for-ipad': 'fmbooth-ipados',
      'photo-mosaic-software': 'pmwall', 'air-graffiti-software': 'air-graffiti-wall-software'
    };
    handle = pageProducts[handle] || handle;
    return catalog.find(p => p.title === page.product_title)
      || [...catalog].sort((a, b) => b.handle.length - a.handle.length).find(p => {
        const escaped = p.handle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return new RegExp('(?:^|[-/])' + escaped + '(?:$|[-/])').test(handle);
      }) || null;
  }
  window.FotoMasterLeadV2Rules = Object.freeze({ priority, prefill });
  window.fotoMasterLeadV2 = function () {
    return {
      config: {}, currentStep: 1, errors: {}, submitError: '', loading: false,
      emailSignupPending: false, country_data: [], countries: [], states: [],
      countryLoading: false, started: false, leadProtection: null, product_catalog: [],
      productSelection: null, form_id: '', session_id: '', _edgeTagDataSent: false,
      _signalportIdentitySent: false, _manualProduct: false, _countryPromise: null,
      form: {
        full_name: '', first_name: '', last_name: '', email: '', phone: '', country: '', state: '',
        company: '', product: '', message: '', intent: '', business_stage: '',
        requirement_option: '', urgency: '', contact_preference: 'email',
        use_case_option: '', use_case_other_option: '', industry_option: '', hear_from_option: '',
        audience_answers_version: '2', entertainment_work: '', has_day_job: '',
        entertainment_goal: '', owner_operator_role: '', audience_processing_permission: '',
        form_variant: 'intent_first', lead_priority: 'nurture',
        email_marketing_requested: false, email_marketing_source: 'form_submission',
        email_marketing_consent_version: 'inquiry-explicit-opt-in-v2'
      },
      init() {
        this.config = JSON.parse(this.$root.querySelector('[data-lead-config]').textContent);
        this.config.requirements = this.config.requirements || [];
        this.config.timings = this.config.timings || [];
        const experiment = this.$root.closest?.('[data-lead-mode]');
        this.form.experiment_mode = experiment?.dataset.leadMode || 'intent_first';
        this.form.experiment_eligible = experiment?.dataset.experimentEligible === 'true';
        this.product_catalog = this.config.products;
        this.productSelection = window.FotoMasterProductSelection.create();
        this.form_id = window.FotoMasterFormIdentity.getOrCreate('contact');
        try { this.session_id = localStorage.getItem('session_id') || ''; } catch (_) {}
        if (!this.session_id) {
          this.session_id = window.crypto?.randomUUID?.() || 'session_' + Date.now() + '_' + Math.random().toString(36).slice(2);
          try { localStorage.setItem('session_id', this.session_id); } catch (_) {}
        }
        const context = window.FotoMasterPageContext || {};
        const product = prefill(this.product_catalog, context, window.location.hash);
        if (product) {
          this.form.product = product.title;
          this.productSelection.recordPrefill(product.title);
          this.form.intent = product.software ? 'software' : 'buy';
          this.currentStep = 2;
        }
        const refreshMirror = () => {
          if (this._manualProduct || product || !window.FotoMasterMirrorPurchase) return;
          const before = this.form.product;
          window.FotoMasterMirrorPurchase.prefill(this.form, this.product_catalog, before);
          if (before !== this.form.product) this.productSelection.recordPrefill(this.form.product);
        };
        refreshMirror();
        document.addEventListener('fm:mirror-choice-ready', refreshMirror, { once: true });
        document.addEventListener('fm:mirror-choice-changed', refreshMirror);
        this._mirrorRefresh = refreshMirror;
        this._protectionReady = () => { if (this.started) this.protect(); };
        document.addEventListener('fm:lead-protection-ready', this._protectionReady);
        this.$nextTick(() => this.diagnose('step'));
      },
      destroy() {
        document.removeEventListener('fm:mirror-choice-ready', this._mirrorRefresh);
        document.removeEventListener('fm:mirror-choice-changed', this._mirrorRefresh);
        document.removeEventListener('fm:lead-protection-ready', this._protectionReady);
        this.leadProtection?.destroy?.();
        this.observePhase(null);
      },
      protect() {
        if (!this.leadProtection && window.FotoMasterLeadProtection) {
          this.leadProtection = window.FotoMasterLeadProtection.create({
            formId: this.form_id, formType: 'contact', formElement: this.$refs.form
          });
        }
      },
      start() {
        if (this.started) return;
        this.started = true;
        this.protect();
        this.emit('start');
      },
      emit(type, extra = {}) {
        this.$root.dispatchEvent(new CustomEvent('fm:lead-form-' + type, { bubbles: true, detail: {
          variant: 'intent_first', step: this.currentStep, intent: this.form.intent,
          business_stage: this.form.business_stage, timeline: this.form.urgency,
          priority: this.form.lead_priority, product: this.form.product, ...extra
        } }));
      },
      // Observability must never gate or change the inquiry flow.
      diagnose(type, detail = {}) {
        try { this.emit(type, detail); } catch (_) {}
      },
      observePhase(phase) {
        this._diagnosticPhase = phase;
        try { window.FotoMasterLeadObservability?.phase(this, phase); } catch (_) {}
      },
      selectIntent(value) {
        if (!intents.includes(value) || this.loading) return;
        this.start();
        this.form.intent = value;
        this.errors = {};
        this.emit('intent');
        if (value === 'rent' || value === 'support') return;
        this.go(value === 'other' ? 3 : 2);
      },
      route() { this.emit('route'); },
      go(step) {
        this.currentStep = step;
        this.submitError = '';
        this.emit('step');
        if (step === 3) this.loadCountries();
        this.$nextTick(() => this.$root.querySelector('[data-lead-step="' + step + '"] legend')?.focus());
      },
      back() {
        if (this.loading) return;
        this.errors = {};
        this.go(this.currentStep === 3 && this.form.intent !== 'other' ? 2 : 1);
      },
      productChanged(event) {
        this._manualProduct = true;
        this.productSelection.recordManual(event);
      },
      async loadCountries() {
        if (this.country_data.length) return;
        if (this._countryPromise) return this._countryPromise;
        this.countryLoading = true;
        this._countryPromise = (async () => {
          try {
            const response = await fetch(this.config.countriesUrl);
            if (!response.ok) throw new Error('Countries unavailable');
            const data = await response.json();
            this.country_data = data;
            this.countries = data.map(c => c.name);
            if (!this.form.country) {
              const detected = data.find(c => c.code2 === this.config.countryCode);
              if (detected) { this.form.country = detected.name; this.updateStates(); }
            }
          } catch (_) {
            this.submitError = this.config.copy.country_error;
            this.diagnose('dependency_error', { processing_stage: 'countries', error_code: 'unavailable' });
          }
          finally { this.countryLoading = false; this._countryPromise = null; }
        })();
        return this._countryPromise;
      },
      updateStates() {
        const country = this.country_data.find(c => c.name === this.form.country);
        this.states = (country?.states || []).map(s => s.name);
        this.form.state = '';
      },
      validate(step) {
        const f = this.form, e = {}, copy = this.config.copy;
        if (step === 2) {
          if (!businesses.includes(f.business_stage)) e.business_stage = copy.required;
          if (!this.config.timings.includes(f.urgency)) e.urgency = copy.required;
        }
        if (step === 3) {
          if (!f.full_name.trim()) e.full_name = copy.required;
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.trim())) e.email = copy.email_error;
          if (!/^\+?[\d\s().-]+$/.test(f.phone.trim()) || f.phone.replace(/\D/g, '').length < 7
              || f.phone.replace(/\D/g, '').length > 15) e.phone = copy.phone_error;
          if (!this.country_data.some(c => c.name === f.country)) e.country = copy.required;
          if (!['email', 'call'].includes(f.contact_preference)) e.contact_preference = copy.required;
          if (f.intent === 'other' && !f.message.trim()) e.message = copy.required;
        }
        this.errors = e;
        if (Object.keys(e).length) {
          for (const field of Object.keys(e)) this.diagnose('validation_error', {
            field_name: field, error_code: ['email', 'phone'].includes(field) ? 'invalid_format' : 'required'
          });
          this.$nextTick(() => {
            const invalid = this.$root.querySelector('[aria-invalid="true"]');
            // A visitor may have closed optional details after choosing Other.
            // Reveal the invalid field before moving keyboard focus to it.
            let details = invalid?.closest('details');
            while (details) {
              details.open = true;
              details = details.parentElement?.closest('details');
            }
            invalid?.focus();
          });
          return false;
        }
        return true;
      },
      async submit(event) {
        if (this.loading || this.emailSignupPending || this.currentStep === 'Done') return;
        this.start();
        if (this.currentStep === 1) return;
        if (this.currentStep === 2) {
          this.diagnose('next_attempt');
          if (this.validate(2)) this.go(3);
          return;
        }
        if (!['buy', 'software', 'other'].includes(this.form.intent)) return;
        this.diagnose('submit_attempt');
        if (this.form.intent !== 'other' && !this.validate(2)) { this.go(2); return; }
        if (!this.validate(3)) return;
        this.loading = true;
        this.submitError = '';
        try {
          // Never reinterpret an invalid international number as a US number.
          this.observePhase('phone');
          await window.loadPhoneLibraries?.();
          if (!window.libphonenumber) {
            const error = new Error('Phone library unavailable');
            error.formDiagnosticCode = 'unavailable';
            throw error;
          }
          const region = this.country_data.find(c => c.name === this.form.country)?.code2;
          const parsed = window.libphonenumber.parsePhoneNumberFromString(this.form.phone, region);
          if (!parsed?.isValid()) {
            this.errors = { phone: this.config.copy.phone_error };
            this.diagnose('validation_error', { field_name: 'phone', error_code: 'invalid_for_country' });
            this.$nextTick(() => this.$refs.phone.focus());
            return;
          }
          this.form.phone = parsed.format('E.164');
          // Keep the complete entered name, with compatible identity fields for CRM/SDKs.
          this.form.full_name = this.form.full_name.trim().replace(/\s+/gu, ' ');
          const [firstName, ...remainingName] = this.form.full_name.split(' ');
          this.form.first_name = firstName;
          this.form.last_name = remainingName.join(' ');
          this.form.email = this.form.email.trim();
          this.form.requirement_option = this.form.business_stage === 'starting' ? (this.config.requirements[0] || '')
            : this.form.business_stage === 'expanding' ? (this.config.requirements[1] || '') : '';
          this.form.lead_priority = this.form.intent === 'other' ? 'nurture' : priority(this.form.urgency);
          const result = await window.FotoMasterLeadSubmit.post(this, event);
          this.observePhase('confirmation');
          await window.FotoMasterLeadSubmit.finish(this, result);
        } catch (error) {
          this.submitError = this.config.copy.submit_error;
          this.diagnose('submit_error', {
            processing_stage: this._diagnosticPhase || 'unknown',
            error_code: error?.formDiagnosticCode || 'exception', http_status: error?.formDiagnosticStatus
          });
        }
        finally { this.observePhase(null); this.loading = false; }
      }
    };
  };
})();
